import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  HELP_DESK_TICKETS,
  HELP_DESK_TICKETS_ALL,
  HELP_DESK_TICKETS_LIST,
  HELP_DESK_TICKETS_OWN,
} from '../constants/actionTypes'

const helpDeskTicketsSelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const helpDeskTicketsSelector = createSelector(helpDeskTicketsSelectors, state => state[HELP_DESK_TICKETS])

export const helpDeskTicketsListSelector = createSelector(
  helpDeskTicketsSelectors,
  state => state[HELP_DESK_TICKETS_LIST]
)

export const helpDeskTicketsAllSelector = createSelector(
  helpDeskTicketsSelectors,
  state => state[HELP_DESK_TICKETS_ALL]
)

export const helpDeskTicketsOwnSelector = createSelector(
  helpDeskTicketsSelectors,
  state => state[HELP_DESK_TICKETS_OWN]
)
